import { useMemo } from 'react';
import { Colors } from '@tapresearch/ui/components';

export const useColorScheme = () => {
  return useMemo(() => {
    const { red, teal, orange, purple, green, fuschia, cyan, forest_green } =
      Colors;
    const colorsArray = [
      red,
      teal,
      orange,
      purple,
      green,
      fuschia,
      cyan,
      forest_green,
    ];
    const colorWeights = [300, 400, 500, 600, 700, 800];
    return colorWeights
      .map((weight) => {
        return colorsArray.map((color) => color[weight as keyof typeof color]);
      })
      .reduce((acc, color) => acc.concat(color), []);
  }, []);
};
